import co2 from "../img/co2.png";
import co2Colored from "../img/co2Colored.png";
import fairtrade from "../img/fairtrade.png";
import fairtradeColored from "../img/fairtradeColored.png";
import organic from "../img/organic.png";
import organicColoerd from "../img/organicColored.png";
import coton from "../img/coton.png";
import cotonColoerd from "../img/cotonColored.png";
import higg from "../img/higg.png";
import higgColored from "../img/higgColored.png";
import global from "../img/global.png";
import globalColored from "../img/globalColored.png";

export const LabelData = [
  {
    img: co2,
    imgColored: co2Colored,
    text:
      "Guarante for universal and cross-sectorial climate effort recognition",
  },
  {
    img: fairtrade,
    imgColored: fairtradeColored,
    text: `Changes the way trade works through better prices, decent working conditions and a fairer deal for farmers and workers in developing countries`,
  },
  {
    img: organic,
    imgColored: organicColoerd,
    text: `Requires that the processing, manufacturing, packaging, labelling, trading and distribution of all textiles are made from at least 70% certified organic natural fibres. Includes ecological and social responsibility`,
  },
  {
    img: coton,
    imgColored: cotonColoerd,
    text: `Makes global cotton production better for the people who produce it, for the environment it grows in  and for the sector’s future`,
  },
  {
    img: higg,
    imgColored: higgColored,
    text: `Assessing environmental and social sustainability throughout the supply chain`,
  },
  {
    img: global,
    imgColored: globalColored,
    text: `Changes the way trade works through better prices, decent working conditions and a fairer deal for farmers and workers in developing countries`,
  },
];
